
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as RelocationOrderModels from '../../models/relocation-order/relocation-order';
import { RelocationOrderSearchModel } from '../../models/relocation-order/relocation-orderSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as OrderStatusModels from '../../models/order/orderStatus';
import * as Models from '../../models/commonModels';
import * as TyreTakeoverOrderModels from '../../models/tyre-takeover-order/tyre-takeover-order';

@Injectable({
  providedIn: 'root'
})

export class RelocationOrderService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService
            ) { }

  public getList(Search: RelocationOrderSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<RelocationOrderModels.RelocationOrderListModel>(`${this.environmentService.getApiURL()}/relocation-order/list`, Search, options);
  }

  public getStatusDictionary() {
    return this.httpClient.get<OrderStatusModels.OrderStatusListModel>(`${this.environmentService.getApiURL()}/relocation-order/status`);
  }

  public getFilteredReport(Search: RelocationOrderSearchModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/relocation-order/report/filtered`, Search, options);
  }

  public set(RelocationOrder: Models.Request<RelocationOrderModels.RelocationOrderModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<RelocationOrderModels.RelocationOrderModel>>(`${this.environmentService.getApiURL()}/relocation-order/set`, RelocationOrder, options);
  }

  public get(RelocationOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<RelocationOrderModels.RelocationOrderModel>>(`${this.environmentService.getApiURL()}/relocation-order/get`, RelocationOrder, options);
  }

  public getOrderProtocolPdf(RelocationOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/relocation-order/pdf-order-protocol`, RelocationOrder, options);
  }

  public getParcelProtocolPdf(Parcel: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/relocation-order/pdf-parcel-protocol`, Parcel, options);
  }

  public getPackageLabelPdf(RelocationOrder: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/relocation-order/pdf-package-label`, RelocationOrder, options);
  }

  public new(RelocationOrder: Models.RequestNewOrder<TyreTakeoverOrderModels.TakeoverDepositesModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<RelocationOrderModels.RelocationOrderModel>>(`${this.environmentService.getApiURL()}/relocation-order/new`, RelocationOrder, options);
  }

  public getTakeoverTyreStateProtocolPdf(TakeoverTyreState: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/relocation-order/pdf-takeover-tyre-state-protocol`, TakeoverTyreState, options);
  }  
}
